import { createAsyncThunk } from '@reduxjs/toolkit';
import { URLS } from 'constants/api.constants';
import { axiosInstance } from 'utils/axios';

// actions/articles.js
export const articleGet = createAsyncThunk(
  'article/article',
  async ({ tag, type }, { thunkAPI }) => {
    try {
      const response = await axiosInstance.get(URLS.ARTICLES.GET_ARTICLE, {
        params: { tag, type },
      });

      if (response.data?.success) {
        return response.data.data.rows;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch articles'
        );
      }
    } catch (error) {
      console.error('Article API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching articles'
      );
    }
  }
);

export const getSingleArticle = createAsyncThunk(
  'article/getsinglearticle',
  async ({ id }, { thunkAPI }) => {
    try {
      const response = await axiosInstance.get(
        `${URLS.ARTICLES.GET_SINGLE_ARTICLE}/${id}`
      );
      if (response.data?.success) {
        return response.data.data;
      } else {
        return thunkAPI.rejectWithValue(
          response.data?.message || 'Failed to fetch article'
        );
      }
    } catch (error) {
      console.error('Article API Error:', error);
      return thunkAPI.rejectWithValue(
        error?.message || 'An error occurred while fetching article'
      );
    }
  }
);
